import { getToken, setToken, removeToken } from '../../utils/token'
import { login, loginOnEmail } from '../../api/user'
import { Dialog, Toast } from 'vant'
import removeInfo from '@/utils/removeInfo'
import { getBrowserInfo } from '@/utils/getBowserInfo'

const getDefaultState = () => {
  return {
    token: getToken()
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  }
}

const actions = {
  // user Login
  async Login ({ commit }, loginForm) {
    try {
      const browserInfo = getBrowserInfo()
      if (browserInfo.flat) {
        const { phone, code, areaCode, imageCode, uuid } = loginForm
        const res = await login(phone, code, areaCode, imageCode, uuid)
        const { token } = res.data
        commit('SET_TOKEN', token)
        setToken(token)
        if (res.code != 200) {
          Toast({ message: res.msg, duration: 1500 })
        }
      } else {
        Dialog.alert({
          message: `经检测，您的浏览器为${browserInfo.name} ${browserInfo.version}版本,为获得更好的使用体验，请使用如下版本浏览器：Chrome（51以上）/Firefox（54以上）/Edge(79以上)/Safari（10以上）/Android Browser（8.1以上）`
        }).then(() => {

        })
      }
    } catch (e) {
      Toast({ message: e, duration: 1500 })
    }
  },

  // 邮箱登录
  async LoginByEmail ({ commit }, loginForm) {
    try {
      const browserInfo = getBrowserInfo()
      if (browserInfo.flat) {
        const { email, code, imageCode, uuid } = loginForm
        const res = await loginOnEmail(email, code, imageCode, uuid)
        const { token } = res.data
        commit('SET_TOKEN', token)
        setToken(token)
        if (res.code != 200) {
          Toast({ message: res.msg, duration: 1500 })
        }
      } else {
        Dialog.alert({
          message: `经检测，您的浏览器为${browserInfo.name} ${browserInfo.version}版本,为获得更好的使用体验，请使用如下版本浏览器：Chrome（51以上）/Firefox（54以上）/Edge(79以上)/Safari（10以上）/Android Browser（8.1以上）`
        }).then(() => {

        })
      }
    } catch (e) {
      Toast({ message: e, duration: 1500 })
    }
  },

  // // user logout
  // logout({ commit, state }) {
  //   removeToken() // must remove  token  first
  //   resetRouter()
  //   commit('RESET_STATE')
  // },

  resetToken ({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
